import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Button,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  Typography,
  Box,
} from "@mui/material";
import { Close as CloseIcon, Error as ErrorIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { FailedUser } from "@shared/types";

export interface FailedUsersModalProps {
  isOpen: boolean;
  onClose: () => void;
  failedUsers: FailedUser[];
  title?: string;
}

const FailedUsersModal: React.FC<FailedUsersModalProps> = ({
  isOpen,
  onClose,
  failedUsers,
  title,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 3,
        },
      }}
    >
      <IconButton
        onClick={onClose}
        className="close-button"
        sx={{ color: "#666" }}
      >
        <CloseIcon />
      </IconButton>

      <DialogTitle
        sx={{
          textAlign: "center",
          pb: 2,
          pt: 3,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
        }}
      >
        <div
          style={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #f44336 0%, #d32f2f 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 8px 24px rgba(244, 67, 54, 0.3)",
          }}
        >
          <ErrorIcon sx={{ color: "white", fontSize: 32 }} />
        </div>
        <Typography variant="h6" component="div">
          {title || t("failedUsersTitle") || "משתמשים שלא נוספו"}
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pt: 1, pb: 2, px: 3 }}>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {t("failedUsersMessage") ||
              "המשתמשים הבאים לא נוספו כי כתובת האימייל שלהם לא שייכת לחשבון Google:"}
          </Typography>
        </Box>

        <List
          sx={{
            maxHeight: 400,
            overflow: "auto",
            bgcolor: "#fafafa",
            borderRadius: 2,
            p: 1,
          }}
        >
          {failedUsers.map((user, index) => (
            <ListItem
              key={index}
              sx={{
                bgcolor: "white",
                mb: 1,
                borderRadius: 1,
                border: "1px solid #e0e0e0",
                "&:last-child": {
                  mb: 0,
                },
              }}
            >
              <ListItemText
                primary={
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {user.name}
                  </Typography>
                }
                secondary={
                  <Box>
                    <Typography variant="body2" color="text.secondary">
                      {user.email}
                    </Typography>
                    <Typography
                      variant="caption"
                      color="error"
                      sx={{ mt: 0.5, display: "block" }}
                    >
                      {user.reason}
                    </Typography>
                  </Box>
                }
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }} style={{ marginBottom: 0 }}>
        <Button
          onClick={onClose}
          variant="contained"
          color="primary"
          fullWidth
        >
          {t("close") || "סגור"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FailedUsersModal;

